import React from "react";
import { Button } from "@/components/ui/button";
import { Plus, BarChart3 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ImportButton } from "@/features/imports/components";

interface HoldingsHeaderProps {
  onAddHolding: () => void;
}

export const HoldingsHeader = ({ onAddHolding }: HoldingsHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex justify-between items-center mb-6">
      <h1 className="text-3xl font-bold">Holdings</h1>

      <div className="flex items-center gap-2">
        <Button variant="outline" onClick={() => navigate("/app/holdings/comparison")}>
          <BarChart3 className="h-4 w-4 mr-2" />
          Compare Periods
        </Button>
        <ImportButton context="holdings" />
      </div>
    </div>
  );
};
